import { z } from 'zod';
export const UserApplicationEmployerStatusSchema = z.object({
    forwardedToAt: z.date().optional(),
    seenAt: z.date().optional(),
    endedAt: z.date().optional(),
    haveFeedback: z.boolean().optional()
});
//# sourceMappingURL=userApplicationEmployerStatus.js.map